import { useState } from "react";
import { Info } from "lucide-react";

/**
 * Ícone de info (ⓘ) com tooltip curto ao passar o mouse OU tocar (mobile).
 * Reusável pra explicadores rápidos — ex: "o que é um agente", "como funciona".
 * Substitui o jargão sem explicação que confundia o usuário leigo (beta do Rafa).
 */
export function InfoTooltip({
  text,
  label = "Saiba mais",
  width = 260,
}: {
  text: string;
  label?: string;
  width?: number;
}) {
  const [open, setOpen] = useState(false);
  return (
    <span
      style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label={label}
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          background: "transparent",
          cursor: "pointer",
          padding: 0,
          color: "var(--wf-ink-3)",
        }}
      >
        <Info size={13} strokeWidth={2} />
      </button>
      {open && (
        <span
          role="tooltip"
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            left: 0,
            zIndex: 50,
            width,
            background: "var(--wf-ink)",
            color: "#f3efe5",
            fontSize: 12,
            fontWeight: 400,
            lineHeight: 1.5,
            padding: "10px 12px",
            borderRadius: 8,
            boxShadow: "0 6px 24px rgba(0,0,0,0.22)",
            textTransform: "none",
            letterSpacing: 0,
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
}
